'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { filterMainBannerItems } from '../../_utils/filterMainBannerItems';
import { DesktopMainBannerSection } from '../DesktopMainBannerSection';
interface MainBannerSectionClientProps {
  className?: string;
}
export const MainBannerSectionClient = t0 => {
  const $ = _c(10);
  const {
    className
  } = t0;
  const {
    entry
  } = useWebviewTypeEntry();
  let t1;
  if ($[0] !== entry) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/home/institution-event/ordered"]({
      query: {
        excludeEndedYN: true,
        entry
      }
    });
    $[0] = entry;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== entry) {
    t2 = res => {
      const list = res.context?.contents ?? [];
      return filterMainBannerItems(list, entry);
    };
    $[2] = entry;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      ...t1,
      select: t2,
      retry: 3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: bannerItems
  } = useSuspenseQuery(t3);
  let t4;
  if ($[7] !== bannerItems || $[8] !== className) {
    t4 = <DesktopMainBannerSection bannerItems={bannerItems} className={className} />;
    $[7] = bannerItems;
    $[8] = className;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};